import axios from '../utils/index';
import { Pat, HttpResponse } from '@/typings/request';
const reportApi = {
    async getReportList(params: Pat) {
        return axios.get(`/task/feedback/list`, { params });
    },
};

export default reportApi;
